import DE from 'country-flag-icons/react/3x2/DE'
import ES from 'country-flag-icons/react/3x2/ES'
import FR from 'country-flag-icons/react/3x2/FR'
import GB from 'country-flag-icons/react/3x2/GB'
import HU from 'country-flag-icons/react/3x2/HU'
import IN from 'country-flag-icons/react/3x2/IN'
import IR from 'country-flag-icons/react/3x2/IR'
import IT from 'country-flag-icons/react/3x2/IT'
import JP from 'country-flag-icons/react/3x2/JP'
import PT from 'country-flag-icons/react/3x2/PT'
import RU from 'country-flag-icons/react/3x2/RU'
import SA from 'country-flag-icons/react/3x2/SA'
import TR from 'country-flag-icons/react/3x2/TR'

/** Matches `country-flag-icons` flag components (HTMLSVGElement props). */
export type FlagComponent = typeof GB

export const LOCALE_COUNTRY_FLAGS: Record<string, FlagComponent> = {
  GB,
  RU,
  SA,
  DE,
  ES,
  IR,
  FR,
  IN,
  HU,
  IT,
  JP,
  PT,
  TR
}
